import { render, staticRenderFns } from "./CustomSpinner.vue?vue&type=template&id=caf580b8&scoped=true"
import script from "./CustomSpinner.vue?vue&type=script&lang=js"
export * from "./CustomSpinner.vue?vue&type=script&lang=js"
import style0 from "./CustomSpinner.vue?vue&type=style&index=0&id=caf580b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf580b8",
  null
  
)

export default component.exports